export const pagesWageLedgerEn = {
  alerts: {
    columns: {
      member: 'Member',
      message: 'Message',
      period: 'Period',
      severity: 'Severity',
      source: 'Source',
      status: 'Status',
      type: 'Type'
    },
    empty: 'No alerts.',
    filters: {
      all: 'All',
      open: 'Open',
      resolved: 'Resolved'
    },
    searchPlaceholder: 'Search by member…',
    severities: {
      high: 'High',
      low: 'Low',
      medium: 'Medium'
    },
    sources: {
      api: 'API',
      csv: 'CSV',
      internal: 'Internal'
    },
    statuses: {
      open: 'Open',
      resolved: 'Resolved'
    },
    types: {
      missing_day_fields: 'Missing day fields',
      negative_net_payment: 'Negative net payment',
      retention_expiring: 'Retention expiring',
      snapshot_unlocked: 'Snapshot unlocked',
      source_mismatch: 'Source mismatch',
      uncalculated_entry: 'Uncalculated entry'
    }
  },
  ledger: {
    addLedgerComingSoon: 'Adding a new wage ledger is coming soon.',
    columns: {
      entries: 'Entries',
      latestNet: 'Latest net pay',
      member: 'Member',
      organization: 'Organization',
      retentionUntil: 'Retain until',
      status: 'Employment contract status',
      year: 'Year'
    },
    detail: {
      backToList: 'Back to wage ledgers',
      breakdown: {
        amount: 'Amount',
        deduction: 'Total deductions',
        deductions: 'Deductions',
        earnings: 'Earnings',
        gross: 'Total gross',
        item: 'Item',
        net: 'Net payment',
        none: 'No breakdown for this period.',
        periodLabel: 'Breakdown period',
        title: 'Earnings & deductions',
        wageClass: 'Wage class'
      },
      calculationLines: {
        columns: {
          amount: 'Amount',
          calculationLog: 'Calculation log',
          category: 'Category',
          itemName: 'Payroll item',
          period: 'Period'
        },
        empty: 'No calculation lines for the selected filters.',
        filterChips: {
          period: 'Wage calculation period',
          wageClass: 'Wage class'
        },
        filters: {
          all: 'All',
          deduction: 'Deductions',
          earning: 'Earnings'
        },
        viewLog: 'View log'
      },
      documentTitle: '{{year}} – {{name}} — Wage ledger',
      documentTitleLoading: 'Wage ledger',
      error: 'Failed to load the wage ledger.',
      header: {
        genders: {
          female: 'Female',
          male: 'Male'
        },
        retentionUntil: 'Retain until',
        separationDate: 'Separation date',
        titlePrefix: 'Wage Ledger:',
        wageType: 'Wage type',
        year: '{{year}}'
      },
      tabs: {
        calculationLines: 'Calculation lines',
        detail: 'Detail'
      },
      wageClasses: {
        A_monthly: 'A (monthly)',
        B_daily_hourly: 'B (daily/hourly)',
        excluded: 'Excluded'
      },
      workingHours: {
        columns: {
          grossTotal: 'Total gross',
          holidayWorkHours: 'Holiday work hours',
          netPayment: 'Net payment',
          nightHours: 'Night work hours',
          overtimeHours: 'Overtime hours',
          period: 'Wage calculation period',
          workDays: 'Working days',
          workHours: 'Working hours'
        }
      }
    },
    empty: 'No wage ledgers.',
    filters: {
      add: 'Add wage ledger',
      all: 'All',
      organization: 'Organization',
      year: 'Year',
      yearValue: '{{year}}'
    },
    searchPlaceholder: 'Search by member…',
    sources: {
      api: 'API',
      csv: 'CSV',
      internal: 'Internal'
    },
    statuses: {
      active: 'Active',
      locked: 'Locked',
      retired: 'Retired'
    },
    wageTypes: {
      annual: 'Flexible annual salary',
      hourly: 'Shift & part-time hourly',
      monthly: 'Monthly salary'
    }
  },
  operationActivity: {
    activityTypes: {
      correctionEntryEdited: 'Entry corrected',
      correctionRetroactiveRecalc: 'Retroactive recalculation',
      importApiSynced: 'API sync import',
      importCsvUploaded: 'CSV import',
      importDayFieldsBackfilled: 'Day fields backfilled',
      importInternalConfirmed: 'Internal confirm import',
      outputLedgerExported: 'Ledger exported',
      outputSeparationCertificateReferenced: 'Separation certificate reference',
      outputStandardMonthlyReferenced: 'Standard monthly reference',
      policyRetentionUpdated: 'Retention policy updated',
      policySourceValidationUpdated: 'Source validation updated',
      snapshotConfirmed: 'Snapshot confirmed',
      snapshotLocked: 'Snapshot locked',
      snapshotReopened: 'Snapshot reopened'
    },
    categories: {
      correction: 'Correction',
      import: 'Import',
      output: 'Output',
      policy: 'Policy',
      snapshot: 'Snapshot'
    },
    columns: {
      activityType: 'Activity',
      category: 'Category',
      detail: 'Detail',
      occurredAt: 'Occurred at',
      origin: 'Origin',
      target: 'Target'
    },
    empty: 'No operation activity.',
    filterByDate: 'Filter by date',
    manual: 'Manual',
    pageTitle: 'Operation Activity',
    showSummary: 'Show summary',
    summary: {
      corrections: 'Corrections',
      events: 'events',
      imports: 'Imports',
      snapshots: 'Snapshots',
      targets: 'targets',
      thisMonth: 'This month',
      thisTerm: 'This fiscal year',
      thisWeek: 'This week'
    },
    system: 'System'
  },
  overview: {
    loading: 'Loading…',
    recentImports: {
      columns: {
        confirmedAt: 'Confirmed at',
        member: 'Member',
        net: 'Net payment',
        period: 'Period',
        source: 'Source'
      },
      empty: 'No recent imports.',
      title: 'Recent imports'
    },
    sourceBreakdown: {
      api: 'API',
      csv: 'CSV',
      internal: 'Internal',
      title: 'Import sources'
    },
    statHints: {
      grossTotalCumulative: 'Sum of gross for the latest period',
      lockedEntries: 'Snapshots locked as source of truth',
      members: 'Members holding a wage ledger',
      monthlyConfirmed: 'Entries confirmed for the latest period',
      pendingEntries: 'Entries awaiting calculation'
    },
    stats: {
      grossTotalCumulative: 'Cumulative gross (latest month)',
      lockedEntries: 'Locked entries',
      members: 'Members with a ledger',
      monthlyConfirmed: 'Confirmed entries (latest month)',
      pendingEntries: 'Uncalculated entries'
    },
    title: 'Overview',
    units: {
      manYen: '万円'
    },
    wageTypes: {
      daily: 'Daily',
      hourly: 'Hourly',
      monthly: 'Monthly'
    }
  },
  pageTitle: 'Wage Ledgers',
  ruleAndPolicy: {
    assignees: '{{count}} applied',
    categories: {
      baseDays: 'Base days',
      output: 'Output',
      retention: 'Retention',
      snapshot: 'Snapshot',
      source: 'Source'
    },
    empty: 'No policies.',
    loading: 'Loading…',
    pageTitle: 'Rule & Policy',
    sideTab: {
      closeSideTab: 'Collapse',
      groups: {
        period: 'Period policies',
        quantity: 'Quantity policies'
      }
    }
  },
  settings: {
    comingSoonNote: 'Editing is primarily done on the payroll calculation side. This screen focuses on viewing, exporting, and supplying data to other applications.',
    sections: {
      output: {
        description: 'Reports and applications reference the ledger, never the payroll engine directly.',
        title: 'Output routing',
        value: 'Via wage ledger'
      },
      retention: {
        description: 'Statutory retention period for the wage ledger.',
        title: 'Retention period',
        value: '5 years'
      },
      snapshot: {
        description: 'Fix the confirmed snapshot so later recalculation cannot shift the basis.',
        title: 'Snapshot fixing',
        value: 'Enabled'
      },
      source: {
        description: 'Internal = event-driven, external = monthly (API / CSV).',
        title: 'Import sources',
        value: 'Internal / API / CSV'
      }
    },
    title: 'Settings'
  },
  tabs: {
    alerts: 'Alerts',
    ledger: 'Wage ledgers',
    operationActivity: 'Operation Activity',
    overview: 'Overview',
    ruleAndPolicy: 'Rule & Policy',
    settings: 'Settings'
  }
};